import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UtilsModule } from '@tablesready/common-ui';
import { BadgeModule } from '@tablesready/frontend-badge';
import { LocationNameColumnComponent } from './location-name-column.component';

@NgModule({
  declarations: [LocationNameColumnComponent],
  imports: [
    CommonModule,
    BadgeModule,
    UtilsModule,
  ],
  exports: [LocationNameColumnComponent],
})
export class LocationNameColumnModule {}
